// Module
var code = " <ng-container *ngIf=\"completed\" [ngTemplateOutlet]=\"templateRef\"></ng-container> <mat-spinner *ngIf=\"loading\"></mat-spinner> <div class=\"warn-color flex-column flex-cross-center\" *ngIf=\"error\"> {{ errorText | translate }} <mat-icon svgIcon=\"gh:info-outline\" class=\"s36\"></mat-icon> </div> ";
// Exports
module.exports = code;